import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

function ReadVersionChatHeader({ result, interrupted }: ToolUseProps) {
  const done = !!result && !result.isError;
  const version = (result?.output as { version?: number } | undefined)?.version;
  const label = version ? `version ${version}` : "published chat";
  return (
    <ToolStatus
      icon="message-circle"
      text={done ? `Read ${label}` : "Reading published chat…"}
      pending={!done && !interrupted}
    />
  );
}

function ReadVersionChatBody({ result }: ToolUseProps) {
  if (!result) return null;
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(result.output, null, 2)}
      </pre>
    </Text>
  );
}

export const readVersionChat: ChatTool = {
  name: "readVersionChat",
  Header: ReadVersionChatHeader,
  Body: ReadVersionChatBody,
};
